<div class="button-container">
  <button  title="Закрыть"
           class="close-button" [mat-dialog-close]="true">
    <mat-icon class="close-icon">close</mat-icon>
  </button>
</div>

<div class="dialog">
  <div class="dialog-header">
    <span>
      <mat-icon class="icon" svgIcon="alarm"></mat-icon>
    </span>
    <span>Ошибка сервера</span>
  </div>

  <div class="dialog-content">
    Произошел сбой загрузки данных. Повторите попытку позднее.
  </div>

  <div class="dialog-actions">
    <button class="back-button" (click)="reloadWindow()" [mat-dialog-close]="true">ОК</button>
  </div>
</div>


